import React, { useState, useEffect } from 'react';

import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormMessageHOC } from 'common/HOCs';
import { Field, reduxForm } from 'redux-form';
import { required } from 'redux-form-validators';
import { FormattedMessage } from 'react-intl';
import BaseButton from 'crm/_components/BaseButton';
import { crmSetUserIBManager } from 'crm/users/_redux/actions';

import { getIBManagerList } from 'crm/users/api';
import BaseAsyncSelectField from '../../fields/BaseAsyncSelectField';

import { staticStyles } from './style';

const CRMEditUserIBManagerForm = ({ handleSubmit, pristine, submitting, invalid, dispatch, error }) => {
  const { id } = useParams();
  const submit = handleSubmit(values => crmSetUserIBManager({ ...values, userId: id }, dispatch));

  const [defaultOptions, setDefaultOptions] = useState([]);

  useEffect(() => {
    getIBManagerList('')
      .then(({ data }) =>
        setDefaultOptions(
          data.map(manager => ({ value: manager.id, label: `${manager.firstName} ${manager.lastName}` }))
        )
      )
      .catch(() => console.log('ERROR'));
  }, []);

  const loadOptions = search =>
    getIBManagerList(search).then(({ data }) =>
      data.map(manager => ({ value: manager.id, label: `${manager.firstName} ${manager.lastName}` }))
    );

  return (
    <form className="CRMEditUserIBManagerForm" onSubmit={submit}>
      <FormattedMessage id="editIBManager">
        {txt => <p className="CRMEditUserIBManagerForm__description">{txt}</p>}
      </FormattedMessage>
      <div className="CRMEditUserIBManagerForm__inputs-inner">
        <Field
          textId="justIBmanager"
          component={BaseAsyncSelectField}
          defaultOptions={defaultOptions}
          removeArrow={!defaultOptions.length}
          searchPromptTextId="Select IB manager"
          name="ibManager"
          loadOptions={loadOptions}
          validate={[required()]}
          disabled={submitting}
          maxMenuHeight={150}
        />
      </div>

      <BaseButton type="submit" textId="justChange" maxContent disabled={invalid || pristine || submitting} />

      {error && <strong className="formError">{error}</strong>}

      <style jsx>{staticStyles}</style>
    </form>
  );
};

CRMEditUserIBManagerForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.string,
};

CRMEditUserIBManagerForm.defaultProps = {
  error: '',
};

export default compose(
  FormMessageHOC,
  reduxForm({
    form: 'crm-edit-user-manager',
    onSubmitSuccess: (result, dispatch, props) => {
      props.showFormSuccessMessage('formSuccessMessageText');
      props.onRequestClose();
    },
  })
)(CRMEditUserIBManagerForm);
export { CRMEditUserIBManagerForm };
